<ion-content [fullscreen]="true" class="page-content" color="light">
  <modal-container [breadcrumbsList]="breadcrumbsList" [hideSaveButton]="!hasReadableValues" [formStatus]="formStatus"
    (onSubmit)="saveConfig()">
    <div class="mentorage-config-page">

      @if (isDataLoading && !snapshot) {
      <div class="state-card centered">
        <ion-spinner name="crescent"></ion-spinner>
        <p>Caricamento configurazione Mentorage in corso...</p>
      </div>
      } @else if (snapshot) {
      <section class="summary-grid">
        <div class="summary-card">
          <span class="summary-label">Snapshot ricevuto</span>
          <span class="status-badge" [ngClass]="getStatusBadgeClass(snapshot.snapshotReceived ? 'ok' : 'missing')">
            {{ snapshot.snapshotReceived ? 'Sì' : 'No' }}
          </span>
        </div>

        <div class="summary-card">
          <span class="summary-label">Refreshed at</span>
          <span class="summary-value">{{ formatDateTime(snapshot.refreshedAt) }}</span>
        </div>

        <div class="summary-card">
          <span class="summary-label">Config status</span>
          <span class="status-badge" [ngClass]="getStatusBadgeClass(config?.status)">{{ config?.status || '--' }}</span>
        </div>

        <div class="summary-card">
          <span class="summary-label">Parse status</span>
          <span class="status-badge" [ngClass]="getStatusBadgeClass(config?.parse_status)">{{ config?.parse_status ||
            '--' }}</span>
        </div>

        <div class="summary-card">
          <span class="summary-label">Hash</span>
          <span class="summary-value code">{{ shortHash }}</span>
        </div>

        <div class="summary-card">
          <span class="summary-label">Last read at</span>
          <span class="summary-value">{{ formatDateTime(config?.last_read_at) }}</span>
        </div>

        <div class="summary-card">
          <span class="summary-label">Last modified at</span>
          <span class="summary-value">{{ formatDateTime(config?.last_modified_at) }}</span>
        </div>

        <div class="summary-card">
          <span class="summary-label">Size</span>
          <span class="summary-value">{{ formatSize(config?.size_bytes) }}</span>
        </div>
      </section>

      @if (!hasSnapshot) {
      <div class="state-card">
        <mat-icon>inventory_2</mat-icon>
        <div>
          <h3>Nessuno snapshot disponibile</h3>
          <p>Nessuno snapshot config ricevuto dal sensore.</p>
        </div>
      </div>
      }

      @if (config?.status === 'missing') {
      <div class="message-banner warning">
        <mat-icon>warning_amber</mat-icon>
        <span>Il file config.yaml non risulta presente sul sensore.</span>
      </div>
      }

      @if (configErrorMessage) {
      <div class="message-banner error">
        <mat-icon>error_outline</mat-icon>
        <span>{{ configErrorMessage }}</span>
      </div>
      }

      @if (valuesOmittedMessage) {
      <div class="message-banner info">
        <mat-icon>info</mat-icon>
        <span>{{ valuesOmittedMessage }}</span>
      </div>
      }

      @if (hasSnapshot && hasReadableValues) {
      <section class="values-section">
        <div class="section-header">
          <h3>Parametri rilevati</h3>
          <p>Vista read-only dei valori pubblicati nello snapshot.</p>
        </div>

        <div class="values-list">
          @for (item of flattenedValues; track item.key) {
          <div class="value-row">
            <span class="value-key">{{ item.key }}</span>
            <div class="value-data editable">
              @if (item.type === 'boolean') {
              <ion-toggle [(ngModel)]="item.boolValue" (ionChange)="onValueChange()"></ion-toggle>
              } @else if (item.type === 'number') {
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="value-input-field">
                <input matInput type="number" [(ngModel)]="item.value" (ngModelChange)="onValueChange()">
              </mat-form-field>
              } @else {
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="value-input-field">
                <input matInput type="text" [(ngModel)]="item.value" (ngModelChange)="onValueChange()">
              </mat-form-field>
              }
            </div>
          </div>
          }
        </div>
      </section>
      } @else if (hasSnapshot && !valuesOmittedMessage && !configErrorMessage && config?.status === 'available') {
      <div class="state-card compact">
        <mat-icon>notes</mat-icon>
        <div>
          <h3>Nessun parametro esposto</h3>
          <p>Lo snapshot è presente ma non contiene valori leggibili da mostrare.</p>
        </div>
      </div>
      }
      } @else {
      <div class="state-card">
        <mat-icon>cloud_off</mat-icon>
        <div>
          <h3>Errore di caricamento</h3>
          <p>Non è stato possibile recuperare la configurazione Mentorage del sensore.</p>
        </div>
      </div>
      }
    </div>
  </modal-container>
</ion-content>